module.exports = "/_next/static/images/sl-2b040d079946e7166e2eaf478d0f5a96.svg";